export enum WidgetType {
	Banner = 'Banner',
	CenteredCarousel = 'Centered-Carousel',
	ClassicCarousel = 'Classic-Carousel',
	SevenImagePanel = '7-Image-Panel',
	Tokens = 'Tokens',
	ImageGrid = 'Image-Grid',
	SingleImage = 'Single-Image',
}
